var map = {
	"./aktia.gif": "0904",
	"./bankid-se.gif": "076e",
	"./danskebank.gif": "e075",
	"./dummy.gif": "6922",
	"./handelsbanken.gif": "9494",
	"./mobiilivarmenne.gif": "9d94",
	"./nordea.gif": "8e21",
	"./olandsbanken.gif": "1053",
	"./omasp.gif": "5a6d",
	"./op.gif": "d30d",
	"./pop.gif": "dc7a",
	"./sp.gif": "696a",
	"./spankki.gif": "284a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1b52";